import EmployeeCategoryService from 'src/modules/employeeCategory/employeeCategoryService';
import selectors from 'src/modules/employeeCategory/list/employeeCategoryListSelectors';
import {i18n} from 'src/i18n';
import exporterFields from 'src/modules/employeeCategory/list/employeeCategoryListExporterFields';
import Errors from 'src/modules/shared/error/errors';
import Exporter from 'src/modules/shared/exporter/exporter';

const prefix = 'EMPLOYEE_CATEGORY_LIST';

const employeeCategoryListActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,
  RESETED: `${prefix}_RESETED`,
  TOGGLE_ONE_SELECTED: `${prefix}_TOGGLE_ONE_SELECTED`,
  TOGGLE_ALL_SELECTED: `${prefix}_TOGGLE_ALL_SELECTED`,
  CLEAR_ALL_SELECTED: `${prefix}_CLEAR_ALL_SELECTED`,
  PAGINATION_CHANGED: `${prefix}_PAGINATION_CHANGED`,
  SORTER_CHANGED: `${prefix}_SORTER_CHANGED`,
  EXPORT_STARTED: `${prefix}_EXPORT_STARTED`,
  EXPORT_SUCCESS: `${prefix}_EXPORT_SUCCESS`,
  EXPORT_ERROR: `${prefix}_EXPORT_ERROR`,

  doClearAllSelected() {
    return {type: employeeCategoryListActions.CLEAR_ALL_SELECTED};
  },
  doToggleAllSelected() {
    return {type: employeeCategoryListActions.TOGGLE_ALL_SELECTED};
  },
  doToggleOneSelected(id) {
    return {type: employeeCategoryListActions.TOGGLE_ONE_SELECTED, payload: id};
  },
  doReset: () => async (dispatch) => {
    dispatch({type: employeeCategoryListActions.RESETED});
    dispatch(employeeCategoryListActions.doFetch());
  },
  doExport: () => async (dispatch, getState) => {
    try {
      if (!exporterFields || !exporterFields.length) throw new Error('exporterFields is required');
      dispatch({type: employeeCategoryListActions.EXPORT_STARTED});
      const filter = selectors.selectFilter(getState());
      const response = await EmployeeCategoryService.list(filter, selectors.selectOrderBy(getState()), null, null);
      new Exporter(exporterFields, i18n('entities.employeeCategory.exporterFileName')).transformAndExportAsExcelFile(
        response.rows,
      );
      dispatch({type: employeeCategoryListActions.EXPORT_SUCCESS});
    } catch (error) {
      Errors.handle(error);
      dispatch({type: employeeCategoryListActions.EXPORT_ERROR});
    }
  },
  doChangePagination: (pagination) => async (dispatch, getState) => {
    dispatch({type: employeeCategoryListActions.PAGINATION_CHANGED, payload: pagination});
    dispatch(employeeCategoryListActions.doFetchCurrentFilter());
  },
  doChangeSort: (sorter) => async (dispatch, getState) => {
    dispatch({type: employeeCategoryListActions.SORTER_CHANGED, payload: sorter});
    dispatch(employeeCategoryListActions.doFetchCurrentFilter());
  },
  doFetchCurrentFilter: () => async (dispatch, getState) => {
    const filter = selectors.selectFilter(getState());
    const rawFilter = selectors.selectRawFilter(getState());
    dispatch(employeeCategoryListActions.doFetch(filter, rawFilter, true));
  },
  doFetch:
    (filter?, rawFilter?, keepPagination = false) =>
    async (dispatch, getState) => {
      try {
        dispatch({
          type: employeeCategoryListActions.FETCH_STARTED,
          payload: {filter, rawFilter, keepPagination},
        });
        const response = await EmployeeCategoryService.list(
          filter,
          selectors.selectOrderBy(getState()),
          selectors.selectLimit(getState()),
          selectors.selectOffset(getState()),
        );
        dispatch({
          type: employeeCategoryListActions.FETCH_SUCCESS,
          payload: {rows: response.rows, count: response.count},
        });
      } catch (error) {
        Errors.handle(error);
        dispatch({type: employeeCategoryListActions.FETCH_ERROR});
      }
    },
};

export default employeeCategoryListActions;
